import F from 'offline/filter/constants'
// Port of api/fuel/app/classes/filter/package/games/collection/prepare/nesting.php
export default {
	run: function(local, global) {
		if (global.ownerType !== F.OWNER_USER) return local
		local.collection = local.collection || {}
		var coll = global.collections ? global.collections[local.id] : null
		var nestedIndex = global.nestedIndex || {}
		var hasNestedChild = Array.isArray(nestedIndex)
			? nestedIndex.indexOf(local.id) !== -1
			: !!nestedIndex[local.id]
		var autoNesting = !!(
			global.settings &&
			global.settings.session &&
			global.settings.session.collection &&
			global.settings.session.collection.nest
		)
		var child = false

		if (coll && coll.collection_nested === F.NESTED_OFFICIAL && autoNesting) {
			child = global.referenceIndex.indexOf(coll.collection_nested_official) !== -1 ? F.NESTED_OFFICIAL : false
		} else if (coll && coll.collection_nested === F.NESTED_CUSTOM) {
			child = global.referenceIndex.indexOf(coll.collection_nested_custom) !== -1 ? F.NESTED_CUSTOM : false
		}

		local.collection.nesting = {
			parent: !!(global.nested[local.id] && global.nested[local.id].length),
			child: child && hasNestedChild ? child : false,
			official: (coll && autoNesting && global.referenceIndex.indexOf(coll.collection_nested_official) !== -1) ? coll.collection_nested_official : false,
			custom: (coll && global.referenceIndex.indexOf(coll.collection_nested_custom) !== -1) ? coll.collection_nested_custom : false
		}
		return local
	}
}
